var State = /** @class */ (function () {
    function State() {
    }
    return State;
}());
export { State };
//# sourceMappingURL=state.js.map